import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { PortalApp } from '../app.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private readonly config = {
    portal: {
      name: 'Portal SSO',
      logoUrl: '/assets/logo.png',
      supportEmail: 'support@entreprise.com'
    },
    // keycloak: {
    //   url: 'https://auth.cineri.sn',
    //   realm: 'sigesr',
    //   clientId: 'portal-sigesr'
    // },
    keycloak: environment.keycloak
  };

  private readonly appMetadata: Record<string, Partial<PortalApp>> = {
    'ine': {
      id: 'ine',
      name: 'INE',
      description: "Application de gestion du numéro d'identification nationale de l'étudiant",
      icon: 'images/apps/ine.svg',
      color: '#2196f3'
    },
    'campusen': {
      id: 'campusen',
      name: 'Campusen',
      description: "Orientation des bacheliers: Paramétrage des critères, liste des demandeurs, listes paiements, etc.",
      icon: 'images/apps/campusen-app.svg',
      color: '#4caf50'
    },
    'dashboard': {
      id: 'dashboard',
      name: 'Tableau de bord',
      description: 'Tous les documents relatifs au tableau de bord du SIGESR',
      icon: 'images/apps/tableau-bord.svg',
      color: '#3f51b5'
    },
    'formation': {
      id: 'formation',
      name: 'Catalogue des formations',
      description: 'Gestion des formations et programmes universitaires',
      icon: 'images/apps/formation.svg',
      color: '#9c27b0'
    },
    'habilitation': {
      id: 'habilitation',
      name: 'SCA',
      description: "Système Centrale d'Authentification - Gestion des habilitations",
      icon: 'images/apps/habilitation.svg',
      color: '#ff9800'
    },
    'inscription': {
      id: 'inscription',
      name: 'Inscription',
      description: 'Inscriptions des étudiants',
      icon: 'images/apps/inscription.svg',
      color: '#8cdae8'
    },
    'deliberation': {
      id: 'deliberation',
      name: 'Délibération',
      description: 'Délibération des étudiants',
      icon: 'images/apps/deliberation.svg',
      color: '#f96345'
    }
  };

  // Clients système à exclure
  private readonly excludedAudiences = [
    'realm-management',
    'broker',
    'account',
    'security-admin-console',
    'admin-cli'
  ];

  getConfig() {
    return this.config;
  }

  /**
   * Retourne une application à partir de son clientId.
   */
  getAppByClientId(clientId: string): PortalApp | null {
    const meta = this.appMetadata[clientId];
    if (!meta) return null;

    // Récupération de l'URL depuis l'environnement
    const url = environment.apps?.[clientId as keyof typeof environment.apps];
    if (!url) {
      console.warn(`[ConfigService] Aucune URL définie pour l'application ${clientId} dans l'environnement courant`);
    }

    return {
      id: meta.id || clientId,
      name: meta.name || clientId,
      description: meta.description || '',
      url: url || '', // ← URL dynamique selon l'environnement
      clientId: clientId,
      requiredRoles: [],
      icon: meta.icon || 'images/apps/default.svg',
      color: meta.color || '#CCCCCC'
    };
  }

  /**
   * Retourne toutes les applications connues.
   */
  getAllApps(): PortalApp[] {
    return Object.keys(this.appMetadata).map(clientId => this.getAppByClientId(clientId)!);
  }

  /**
   * Retourne la liste des audiences exclues.
   */
  getExcludedAudiences(): string[] {
    return [...this.excludedAudiences];
  }
}